import { memo } from 'react';
import { CircularProgress } from '@mui/material';

import { LoaderSize } from 'types/enums.ts';

interface Props {
  id?: string;
  size?: LoaderSize | number;
  classname?: string;
}

export const Loader = memo(({ classname, size = LoaderSize.md, id = 'circular-progress' }: Props) => (
  <div className={`${classname}`} data-testid={`${id}-container`}>
    <CircularProgress size={size} data-testid={`${id}-progress`} />
  </div>
));
